<template>
  <div>
    <Poptip trigger="hover" translate width="60" placement="bottom">
        <Icon type="social-usd"
              style="color:#eec900;font-size:18px;margin-right: 6px;vertical-align: text-bottom;cursor: pointer">
        </Icon>
        <span style="cursor:pointer">{{contact.name}}</span>
      <div slot="content" style="text-align: center">
        <Button v-if="roleType == 'dsyy'" type="primary" size="small" @click="allot">分配</Button>
        <br/>
        <Button type="primary" size="small" @click="noShop" style="margin-top:8px;">未到店</Button>
      </div>
    </Poptip>

    <Modal v-model="allotModal" title="分配客资" :width="360" class="TextOverflow">
      <div style="height: 54px; margin-top: 24px; text-align: center;">
        <span style="margin-left: -8px;">分配人员：</span>
        <Dropdown trigger="click" style="height:32px;text-align: left">
          <Button type="ghost" size="small" style="width:176px;height:32px;background:#ffff;">
            <span class="dropdown_names"
                  style="float:left;width: 140px;text-align:left;text-overflow: ellipsis;overflow: hidden">{{alloutValue}}</span>
            <Icon type="arrow-down-b" style="float:right;margin-top:4px;"></Icon>
          </Button>
          <DropdownMenu slot="list" class="dropdown_selections">
            <Tree :data="allotData" show-checkbox style="width:148px;" empty-text="暂无数据"
                  @on-check-change="fChangeAlloutValue"></Tree>
          </DropdownMenu>
        </Dropdown>
      </div>
      <div slot="footer" style="text-align: center">
        <Button type="primary" @click="fSubmitAllot" :loading="allotLoading">确定</Button>
        <Button type="ghost" @click="fToolModal">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import {Poptip,Tree, Dropdown, DropdownMenu} from 'iview'
  import api from '../../api'

  export default {
    name: "render-contact",
    props:{
      rowData:{
        type:Object
      }
    },
    data(){
      return{
        allotLoading: false,
        allotModal: false,
        alloutValue: '请选择分配人员',
        allotData: [],
        allSelectValue: '',
      }
    },
    components: {
      Poptip,Tree, Dropdown, DropdownMenu
    },
    computed:{
      ...mapGetters(['pageDict','roleType']),

      contact(){
        let name = this.pageDict.statusMap[this.rowData.statusid].statusName
        return{name:name}
      },
    },
    methods:{
      //分配
      allot(){
        let staffState = {
          0:'离线',
          8:'停单',
          9:'满限',
        }
        let state = this.roleType
        let stateRole = ''
        if(state == 'dscj' || state == 'dssx'){
          stateRole = 'dsyy'
        }else if(state == 'dsyy' || state == 'zjsyy' || state == 'msjd' || state == 'cwzx'){
          stateRole = 'msjd'
        }else if(state == 'zjssx'){
          stateRole = 'zjsyy'
        }
        api.conditionTreeData.getServiceCustomAllot(stateRole).then(data => {
          if (data.code === 100000) {
            let storeData = data.data.map(item => {
              let staffArray = []
              if (Object.getOwnPropertyNames(item.staffList).length > 1) {
                item.staffList.map(list => {
                  if(!list.lockFlag){
                    let title = staffState[list.statusFlag]?`${list.staffName}(${staffState[list.statusFlag]})`:list.staffName
                    staffArray.push({
                      expand: false,
                      id: list.staffId,
                      title: title,
                    })
                  }
                })
              }
              return {
                expand: false,
                id: item.groupId,
                title: item.groupName,
                children: staffArray
              }
            })
            this.allotData = storeData
          }
          this.allotModal = true
        })
      },


      //分配客资人员统计
      fChangeAlloutValue(val) {
        let text = ''
        let id = ''
        if (!val.children || !val.children.length) {
          val.forEach(item => {
            if (!item.disabled && !item.children) {
              text += item.title + ','
              id += item.id + ','
            }
          })
        }
        if (text === '') {
          text = '请选择分配人员'
        }
        this.allSelectValue = id
        this.alloutValue = text
      },

      //确认分配客资
      fSubmitAllot() {
        if (this.allSelectValue.length > 0) {
          this.allotLoading = true
          this.$http.post('/track/allot', {
            kzIds: this.rowData.kzid,
            staffIds: this.allSelectValue,
            role:this.roleType,
          }).then((data) => {
            if (data.code === 100000) {
              this.allotData = []
              this.allSelectValue = []
              this.alloutValue = '请选择分配人员',
                this.$Message.success(data.msg)
              this.allotModal = false
              this.fToolModal()
              this.$Loading.start()
              this.$store.commit('setSerciveLoad', true)
              this.$bus.emit('pull-kz-data')
            } else {
              this.$Message.error(data.msg)
            }
            this.allotLoading = false
          })
        } else {
          this.$Message.warning('请先选择要分配给的人员')
        }
      },

      //关闭模态框
      fToolModal() {
        this.allotModal = false
        this.allSelectValue = []
        this.allotData = []
        this.alloutValue = '请选择分配人员'
      },

      //未到店
      noShop(){
        this.$http.post('/track/allot_not_arrive_shop',{
            kzId:this.rowData.kzid
        }).then(data=>{
          if(data.code === 100000){
            this.$Message.success(data.msg)
            this.fToolModal()
            this.$Loading.start()
            this.$store.commit('setSerciveLoad', true)
            this.$bus.emit('pull-kz-data')
          }else{
            this.$Message.error(data.msg)
          }
        })
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/render-components/render-contact.vue